// extracted by mini-css-extract-plugin
export default {"menu-item":"MenuItem_style__menu-item___ae","disabled":"MenuItem_style__disabled___c5","active":"MenuItem_style__active___bb"};